import { LuFileText, LuMinus, LuPlus, LuUpload } from "react-icons/lu";
import Button from "../../../common/Buttons";
import SectionHeading from "./SectionHeading";

export default function QuotationStep({
  quoteData,
  selectedQuotationNames,
  setSelectedQuotationNames,
  handleQuotationRemove,
  quoteItemSelection,
  selectedQuoteItemIds,
  toggleQuoteItemSelect,
  pendingFile,
  setPendingFile,
  handleQuoteApply,
}) {
  return (
    <div>
      <SectionHeading hint="Optional — attach supplier quotations and link them to the items they cover.">
        Upload Price Quotation
      </SectionHeading>

      {quoteData.length > 0 && (
        <div className="mb-4 space-y-1.5">
          {quoteData.map((q) => {
            const checked = selectedQuotationNames.includes(q.file.name);
            return (
              <label
                key={q.file.name}
                className={`flex items-start gap-2.5 rounded-lg border p-2.5 text-[12px] transition-colors ${
                  checked ? "border-brand-400 bg-brand-50/60" : "border-slate-200 hover:bg-slate-50"
                }`}
              >
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() =>
                    setSelectedQuotationNames((prev) =>
                      checked ? prev.filter((n) => n !== q.file.name) : [...prev, q.file.name],
                    )
                  }
                  className="mt-0.5 h-4 w-4 shrink-0 rounded border-slate-300 text-brand-600"
                />
                <LuFileText size={16} className="mt-0.5 shrink-0 text-slate-400" />
                <div className="min-w-0">
                  <p className="truncate font-medium text-slate-700">{q.file.name}</p>
                  <p className="truncate text-slate-400">{Object.values(q.items).join(" · ")}</p>
                </div>
              </label>
            );
          })}
          <button
            onClick={handleQuotationRemove}
            disabled={selectedQuotationNames.length === 0}
            className="mt-1 flex items-center gap-1 text-[12px] font-medium text-red-600 disabled:opacity-40"
          >
            <LuMinus size={13} /> Remove selected
          </button>
        </div>
      )}

      {Object.keys(quoteItemSelection).length > 0 ? (
        <div className="rounded-xl border border-slate-200 p-3.5">
          <p className="mb-2 text-[12px] font-medium text-slate-600">Select item(s) this quotation covers</p>
          <div className="max-h-40 space-y-1.5 overflow-y-auto pr-1">
            {Object.entries(quoteItemSelection).map(([id, label]) => (
              <label key={id} className="flex items-center gap-2 text-[12px] text-slate-700">
                <input
                  type="checkbox"
                  checked={selectedQuoteItemIds.includes(id)}
                  onChange={() => toggleQuoteItemSelect(id)}
                  className="h-4 w-4 shrink-0 rounded border-slate-300 text-brand-600"
                />
                <span className="truncate">{label}</span>
              </label>
            ))}
          </div>

          <label
            className={`mt-3 flex cursor-pointer items-center gap-3 rounded-lg border-2 border-dashed p-3 text-[12px] transition-colors ${
              pendingFile ? "border-brand-300 bg-brand-50/50" : "border-slate-200 hover:border-slate-300"
            }`}
          >
            <LuUpload size={18} className="shrink-0 text-slate-400" />
            <span className="min-w-0 flex-1 truncate text-slate-500">
              {pendingFile ? pendingFile.name : "Click to choose a quotation file"}
            </span>
            <input
              type="file"
              onChange={(e) => setPendingFile(e.target.files?.[0] || null)}
              className="hidden"
            />
          </label>

          <Button
            variant="solid"
            icon={<LuPlus size={13} />}
            disabled={selectedQuoteItemIds.length === 0 || !pendingFile}
            onClick={handleQuoteApply}
            className="mt-3 w-full sm:w-auto"
          >
            Apply Quotation
          </Button>
        </div>
      ) : (
        <p className="rounded-lg bg-slate-50 p-3 text-[12px] text-slate-400">
          All items already have a quotation applied.
        </p>
      )}
    </div>
  );
}